import React from 'react';
import { Route } from 'react-router-dom';
// импортваме си компонентите
import CloseWindow from '../Tasks/components/CloseWindow';
import { Tasks, ColleagueList, ColleagueMenu } from '../Tasks';
import { reducer } from '../Tasks/redux';
import { reducer as appFeaturesReducer } from '../AppFeatures/redux';
import { reducer as chatReducer } from '../Chat/redux';

// https://marmelab.com/react-admin/doc/3.2/Resource.html
// за всеки обект в масива ще бъде създаден react admin Resource component
// следното е наше решение: първата част преди тирето трябва да съвпада с ключа в обекта микросервизи за да вземе неговата стойност която е url към съответния микросервиз
// така react admin който по принцип прави автоматично заявки от основните си компоненти ще знае към кой url да се обърне
// втората част след тирето представлява името на контролера в съответния микросервиз, участва отново в зглобяването на url за http заявки
// освен горепосоченото втората част също така се използва за създаването на url в приложението react router route (https://reacttraining.com/react-router/web/guides/quick-start)
const templateResources = [
  {
    name: 'technicians-tasks',
    list: ColleagueList,
  },
];
const microservices = {
  technicians: process.env.REACT_APP_TECHNICIANS_API,
};

// за не react admin страници трябва сами да си създадем url и да посочим кой компонент че се рисува
// customRoutes приема масив от react router route компоненти
const customRoutes = [
  <Route exact path="/technicians-app" component={Tasks} />,
  <Route exact path="/close-window" component={CloseWindow} />,
];

// https://react-redux.js.org/
// тук добавяме нашите reducer функции
const customReducers = {
  tasks: reducer,
  features: appFeaturesReducer,
  chat: chatReducer,
};

// навигационно меню
const customMenu = () => React.createElement(ColleagueMenu);

export { templateResources, microservices, customRoutes, customReducers, customMenu };
